import { FormTextField, SearchRoundedIcon } from '@shared/components';
import debounce from 'lodash/debounce';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import type { SearchAndFilterParams } from '../../provider';
import { useUserList } from '../../provider/use-user-list';

interface UserSearchBoxProps {
  hasFullWidth?: boolean;
}

export function UserSearchBox(props: Readonly<UserSearchBoxProps>) {
  const { hasFullWidth = false } = props;
  const { searchAndFilterInput, setSearchAndFilterInput, setDataGridParams } = useUserList();
  const formContext = useForm<{ search: SearchAndFilterParams['search'] }>({
    defaultValues: { search: searchAndFilterInput.search ?? '' },
  });
  const { watch, control } = formContext;

  const setSearchParams = (formValues: { search: SearchAndFilterParams['search'] }) => {
    setSearchAndFilterInput({ search: formValues.search?.toString().trim() ?? '' });
    setDataGridParams({ page: 0 });
  };

  useEffect(() => {
    const subscription = watch(debounce((formValues) => setSearchParams(formValues), 700));

    return subscription.unsubscribe;
  }, [watch, setSearchParams]);

  return (
    <FormTextField
      placeholder='ค้นหาผู้ใช้...'
      name='search'
      control={control}
      fullWidth={hasFullWidth}
      sx={{ minWidth: 318 }}
      slotProps={{
        input: {
          startAdornment: <SearchRoundedIcon sx={{ color: 'grey.600' }} />,
        },
      }}
    />
  );
}
